import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { siteLinks } from "../data/site";
import { BrandMark } from "./BrandMark";
const footerNavigation = [{
  label: "Method",
  href: "#method"
}, {
  label: "Assessment",
  href: "#assessment"
}, {
  label: "Online Coaching",
  href: "#online-coaching"
}, {
  label: "Denver Coaching",
  href: "#denver-coaching"
}, {
  label: "About",
  href: "#about"
}, {
  label: "FAQ",
  href: "#faq"
}];
export function Footer() {
  const social = [{
    label: "Instagram",
    href: siteLinks.instagram
  }, {
    label: "TikTok",
    href: siteLinks.tiktok
  }];
  const legal = [{
    label: "Privacy",
    href: siteLinks.privacy
  }, {
    label: "Terms",
    href: siteLinks.terms
  }, {
    label: "Contact",
    href: siteLinks.contact
  }];
  return <footer id="footer" className="bg-ink px-5 pb-28 pt-20 text-cream sm:px-8 sm:pb-12 lg:px-12" data-id="element-56" data-mp="3qblxrrofsg2n">
      <div className="mx-auto max-w-[1500px]" data-id="element-57" data-mp="29xvrce9uhfpu">
        <div className="grid gap-14 border-b border-cream/20 pb-16 md:grid-cols-[1.4fr_0.8fr_0.8fr]" data-id="element-58" data-mp="2eyt8cnj4c3pr">
          <div data-id="element-59" data-mp="3l90pe0juz71d"><BrandMark light data-id="element-60" data-mp="3l8qvw2zluhqx" /><p className="mt-8 max-w-md font-display text-3xl font-semibold uppercase leading-tight tracking-[-0.025em]" data-id="element-61" data-mp="3labovo69tsmo">Move <span className="text-bronze" data-id="element-62" data-mp="3gc0glhvmjq6k">•</span> Mind <span className="text-bronze" data-id="element-63" data-mp="3v7gejxzbs688">•</span> Spirit <span className="text-bronze" data-id="element-64" data-mp="3v8hpm2gccspy">•</span> Purpose</p><p className="mt-7 max-w-sm text-sm leading-7 text-cream/55" data-id="element-65" data-mp="3q8n0a3c7sb70">Assess first. Then build.</p></div>
          <nav aria-label="Footer navigation" data-id="element-66" data-mp="82qrxrmhzrt7"><p className="mb-5 text-[10px] font-bold uppercase tracking-[0.2em] text-sand" data-id="element-67" data-mp="81yyamcgo45k">Explore</p><ul className="space-y-3" data-id="element-68" data-mp="34p6j01lngek">{footerNavigation.map(item => <li key={item.label} data-id="element-69" data-mp="3230j4ucx8yg"><a href={item.href} className="text-sm text-cream/65 transition-colors duration-200 ease-out hover:text-cream" data-id="element-70" data-mp="hsk0ejrcfqt8">{item.label}</a></li>)}</ul></nav>
          <div data-id="element-71" data-mp="cuijo5he43kx"><p className="mb-5 text-[10px] font-bold uppercase tracking-[0.2em] text-sand" data-id="element-72" data-mp="cuihpzxtxtia">Connect</p><ul className="space-y-3" data-id="element-73" data-mp="qu1j89w4y6lm">{social.map(item => <li key={item.label} data-id="element-74" data-mp="ms6h536drp6s"><a href={item.href} className="inline-flex items-center gap-2 text-sm text-cream/65 transition-colors duration-200 ease-out hover:text-cream" data-id="element-75" data-mp="mspqhvhyt597">{item.label}<ArrowUpRightIcon className="h-3.5 w-3.5" data-id="element-76" data-mp="tt9ymcuumrvn" /></a></li>)}<li className="pt-4 text-[10px] font-bold uppercase tracking-[0.16em] text-cream/45" data-id="element-77" data-mp="yv935q2bruu6">English / Español</li></ul></div>
        </div>
        <div className="flex flex-col gap-5 pt-7 text-[10px] uppercase tracking-[0.13em] text-cream/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-78" data-mp="13r7pz98094sh"><p data-id="element-79" data-mp="1cmdwybj0hswl">© {new Date().getFullYear()} Leo Tovar Method</p><div className="flex flex-wrap gap-5" data-id="element-80" data-mp="1cnoy03l2omk0">{legal.map(item => <a key={item.label} href={item.href} className="transition-colors duration-200 ease-out hover:text-cream" data-id="element-81" data-mp="1hjnukegk1avi">{item.label}</a>)}</div></div>
      </div>
    </footer>;
}